import apiService from "./apiServices";

export const savePolicy = async(formData, token) => {
    try {
        const response = await apiService('/policy/save', 'POST', formData, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Saving policy is failed. Please try again.');
        }
  }

  export const updatePolicy = async (formData, token) => {
    try {
      const response = await apiService('/policy/update', 'PUT', formData, null, token);
      return response;
      } catch (error) {
        throw (error?.message || 'Updating Save policy is failed. Please try again.');
      }
  }

  export const getAllPolicy = async (token,page,size) => {
    try {
      const response = await apiService(`/policy/all?page=${page}&size=${size}&sort=desc`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }

  export const deletePolicyById = async (id, token) => {
    try {
      const response = await apiService(`/policy/delete/${id}`, 'DELETE', null, null, token);
      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }

 export const getDetailPolicy = async (token, id, page, size) => {
  try {
    const response = await apiService(
      `/policy/detailed-view/${id}?transactionPage=${page}&transactionSize=${size}`,
      'GET',
      null,
      null,
      token
    );
    return response;
  } catch (error) {
    throw error?.message || 'Service failed. Please try again.';
  }
};

// services/policyService.js
// services/policy.js
export const getDetailPolicyPagination = async ({
  token,
  id,
  pagination,
  section,
  page,
  size,
}) => {
  // helper to coerce numbers safely
  const coerceNum = (v, def) => {
    if (v == null) return def;
    if (typeof v === "object") {
      if (Number.isFinite(v.page)) return v.page;
      if (Number.isFinite(v.number)) return v.number;
      return def;
    }
    const n = Number(v);
    return Number.isFinite(n) ? n : def;
  };

  // Defaults
  const DEFAULTS = {
    driverPage: 0,
    driverSize: 5,
    coveragePage: 0,
    coverageSize: 10,
    vehiclePage: 0,
    vehicleSize: 5,
  };

  // Derive dynamic DRIVER values
  let driverPage = DEFAULTS.driverPage;
  let driverSize = DEFAULTS.driverSize;

  if (pagination?.driver) {
    driverPage = coerceNum(pagination.driver.page, DEFAULTS.driverPage);
    driverSize = coerceNum(pagination.driver.size, DEFAULTS.driverSize);
  } else if (section === "driver") {
    driverPage = coerceNum(page, DEFAULTS.driverPage);
    driverSize = coerceNum(size, DEFAULTS.driverSize);
  }

  // Derive dynamic VEHICLE values
  let vehiclePage = DEFAULTS.vehiclePage;
  let vehicleSize = DEFAULTS.vehicleSize;

  if (pagination?.vehicle) {
    vehiclePage = coerceNum(pagination.vehicle.page, DEFAULTS.vehiclePage);
    vehicleSize = coerceNum(pagination.vehicle.size, DEFAULTS.vehicleSize);
  } else if (section === "vehicle") {
    vehiclePage = coerceNum(page, DEFAULTS.vehiclePage);
    vehicleSize = coerceNum(size, DEFAULTS.vehicleSize);
  }

  // Derive dynamic COVERAGE values (optional - currently fixed)
  let coveragePage = DEFAULTS.coveragePage;
  let coverageSize = DEFAULTS.coverageSize;

  if (pagination?.coverage) {
    coveragePage = coerceNum(pagination.coverage.page, DEFAULTS.coveragePage);
    coverageSize = coerceNum(pagination.coverage.size, DEFAULTS.coverageSize);
  } else if (section === "coverage") {
    coveragePage = coerceNum(page, DEFAULTS.coveragePage);
    coverageSize = coerceNum(size, DEFAULTS.coverageSize);
  }

  const params = new URLSearchParams();
  // Dynamic driver (FIXED!)
  params.set("driverPage", String(driverPage));
  params.set("driverSize", String(driverSize));
  // Dynamic vehicle
  params.set("vehiclePage", String(vehiclePage));
  params.set("vehicleSize", String(vehicleSize));
  // Dynamic coverage
  params.set("coveragePage", String(coveragePage));
  params.set("coverageSize", String(coverageSize));

  const qs = params.toString();
  return apiService(`/policy/detailed-view/${id}?${qs}`, "GET", null, null, token);
};


export const getPremiumVehiclesPageService = async (
  token,
  policyId,
  { page = 0, size = 5 } = {}
) => {
  try {
    const qs = new URLSearchParams({
      vehiclePage: String(page),
      vehicleSize: String(size),
    }).toString();

    // Return full payload (action can pick .vehicles)
    const response = await apiService(
      `/policy/detailed-view/${policyId}?${qs}`,
      "GET",
      null,
      null,
      token
    );
    return response;
  } catch (error) {
    throw error?.message || "Fetching premium vehicles page failed. Please try again.";
  }
};



  export const getPolicyById = async (token,id) => {
    try {
      const response = await apiService(`/policy/${id}`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }

  export const getSearchPolicyList = async (token,policyId,page,size) => {
    try {
      const response = await apiService(`/notes/policy/${policyId}?page=${page}&size=${size}`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }

  export const getPolicyPremiumDetailServices = async (token,id) => {
    try {
      const response = await apiService(`/policy/${id}/coverage-limits`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw (error?.message || 'service is failed. Please try again.');
    }
  }

  export const savedCustomerPolicyList = async(firstName, lastName, dateOfBirth, phoneNumber, token) => {
    try {
        const response = await apiService(`/client-customers/NameAndDob/${firstName}/${lastName}/${dateOfBirth}/${phoneNumber}`, 'GET', null, null, token);
        return response;
        } catch (error) {
          throw (error?.message || 'Saving policy is failed. Please try again.');
        }
  }
  export const getVehiclePremiumByPolicyId = async (token, policyId, page,size) => {
    try {
      const response = await apiService(`/policy/${policyId}/premium-details?page=${page}&size=${size}`, 'GET', null, null, token);
      return response;
    } catch (error) {
      throw new Error(error.message || 'fetching vehicle premium is failed. Please try again.');
    }
  }
   export const getCoveragelisting = async (id,page, size,token) => {
      try {
          const response = await apiService(`/policy/detailed-view/${id}?driverPage=0&driverSize=5&vehiclePage=${page}&vehicleSize=${size}&coveragePage=0&coverageSize=10`, 'GET', null, null, token);
          return response;
        } catch (error) {
          throw (error?.message || 'service is failed. Please try again.');
        }
    }

export const deleteDriverService = async (id, token) => {
    try {
      const response = await apiService(`/driver/delete/${id}`, 'DELETE', null, null, token);
      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }

export const deleteVehicleService = async (id, token) => {
    try {
      const response = await apiService(`/vehicle/delete/${id}`, 'DELETE', null, null, token);
      return response;
    } catch (error) {
      throw new Error(error.message || 'service is failed. Please try again.');
    }
  }